import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { SnackbarService } from '../../../../services/snackbar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { Combo, ComboService } from '../../../../services/combo.service';
import {
  CampanacontrollerService,
  CampanaAdheridosControllerService,
  CampanaDTO,
  CampanaPayloadDTO,
  CampanaGestoresResiduosControllerService, 
  CampanaPoseedoresControllerService,
  ParametrosControllerService,
} from 'api-rest';
import Swal from 'sweetalert2';

@Component({
  selector: 'lib-declaration-campaign-dialog',
  templateUrl: './declaration-campaign-dialog.component.html',
  styleUrls: ['./declaration-campaign-dialog.component.scss']
})
export class DeclarationCampaignDialogComponent {
  campania: any;
  formGroup!: FormGroup;
  tipoCampanias: Combo[] = [];
  titulo: String = '';
  campaniaId!: number;
  soloLectura: Boolean;
  defaultFilter: boolean = true;
  fechaLimiteSuperiorRaw: { day: number, month: number } | undefined;
  campanasAsociadas: CampanaDTO[] = [];

  constructor(
      @Inject('environment') private environment: any,
      public dialogRef: MatDialogRef<DeclarationCampaignDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private formBuilder: FormBuilder,
      private snackbarService: SnackbarService,
      private comboService: ComboService,
      public spinnerSrv: SpinnerService,
      private snackBarSrv: SnackbarService,
      public CamapanaService: CampanacontrollerService,
      public CamapanaAdheridosService: CampanaAdheridosControllerService,
      public CamapanaGestoresResiduosService: CampanaGestoresResiduosControllerService,
      public CamapanaPoseedoresService: CampanaPoseedoresControllerService,
      @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
      private parametrosControllerService: ParametrosControllerService
    ) {
      this.campaniaId = this.data.campaniaId;
      this.soloLectura = this.data.soloLectura;
    }

  ngOnInit(): void {
    this.initializeForm();
    this.tipoCampanias = this.comboService.getComboTiposCampanias();

    this.parametrosControllerService.findAll7().subscribe({
        next: (parametros: any) => {
          const parametro = parametros.find((p: any) => p.id === 4);
          if (parametro?.valor) {
            const parts = parametro.valor.split('/');
            if (parts.length >= 2) {
                this.fechaLimiteSuperiorRaw = {
                    day: +parts[0],
                    month: +parts[1]
                };
            }
          }
        }
    });

    if (this.campaniaId) {
      this.titulo = 'Detalle de campaña';
      this.cargarCampania(this.campaniaId)
    } else {
      this.titulo = 'Nueva campaña';
      this.formGroup.get('tipo')?.setValue(this.data?.tipoDefault);
    }
  }

  cargarCampania(idSolicitud: number): void {
      this.CamapanaService.getById(idSolicitud)
        .subscribe({
          next: (response: CampanaDTO) => {
            this.campania = response;
            this.cargarDatos(this.campania);
            this.comprobarEdicion(this.campania);
            
            if (response.tipo === 'CVFPoseedor' && response.anio) {
              this.cargarCampanasAsociadas(response.anio);
            }
          },
          error: (err) => {

          },
        });
  }

  cargarCampanasAsociadas(anio: number) {
    if (!anio) return;

    var filter: any = {
      tipo: 'CVFGestor',
      anio: anio
    };
    this.CamapanaService.findAll6(filter, { page: 0, size: 1000, sort: ['id,desc'] }).subscribe({
      next: (response: any) => {
        this.campanasAsociadas = response.datos || [];
      }
    });
  }

  cargarDatos(campania: CampanaDTO): void {
      const tipoId = (campania.tipo && typeof campania.tipo === 'object') ? (campania.tipo as any).id : campania.tipo;
      let tipoCampana = tipoId === 'DAE' ? this.tipoCampanias[0] : tipoId === 'CVFGestor' ? this.tipoCampanias[1] : this.tipoCampanias[2];

      let fechaInicio = new Date(campania?.fechaInicio!)
      let horaInicio = fechaInicio.getHours() + ':' + fechaInicio.getMinutes()
      let fechaFin = new Date(campania?.fechaFinalizacion!)
      let horaFin = fechaFin.getHours() + ':' + fechaFin.getMinutes()

      this.formGroup.patchValue({
        tipo: tipoCampana,
        anio: campania?.anio,
        fechaInicio: campania?.fechaInicio,
        horaInicio: horaInicio,
        fechaFinalizacion: campania?.fechaFinalizacion,
        horaFinalizacion: horaFin,
        descripcion: campania?.descripcion,
        campanaAsociada: campania?.campanaAsociada
      });
      
      if (campania.tipo === 'CVFPoseedor') {
          this.actualizarValidacionCampanaAsociada(true);
      }

  }

  comprobarEdicion(campania: CampanaDTO): void {
    if (this.campaniaId) {
      const tipoId = (campania.tipo && typeof campania.tipo === 'object') ? (campania.tipo as any).id : campania.tipo;

      if (tipoId === 'CVFGestor' && campania.estado?.id === 5) {
        this.soloLectura = true;
        this.formGroup.disable();
        return;
      }

      if (tipoId === 'CVFPoseedor') {
        if (campania.estado?.id !== 5) {
          this.soloLectura = false;
          this.formGroup.get('fechaInicio')?.enable();
          this.formGroup.get('fechaFinalizacion')?.enable();
          this.formGroup.get('horaInicio')?.enable();
          this.formGroup.get('horaFinalizacion')?.enable();
          this.formGroup.get('descripcion')?.enable();

          if (campania.estado?.id === 1) {
            this.formGroup.get('campanaAsociada')?.enable();
          } else {
            this.formGroup.get('campanaAsociada')?.disable();
          }
        } else {
          this.soloLectura = true;
          this.formGroup.disable();
        }
        return;
      }

      let fechaInicio = new Date(campania.fechaInicio!!);
      let fechaActual = new Date();
      fechaActual.setHours(fechaActual.getHours() + 2)

      if ((fechaInicio > fechaActual) || (tipoId === 'CVFGestor')) {
        this.soloLectura = false;

        if (tipoId !== 'CVFGestor') {
          this.formGroup.get('descripcion')?.enable();
        } else {
          this.formGroup.get('descripcion')?.disable();
        }

        this.formGroup.get('fechaInicio')?.enable();
        this.formGroup.get('fechaFinalizacion')?.enable();
        this.formGroup.get('horaInicio')?.enable();
        this.formGroup.get('horaFinalizacion')?.enable();
      }
    }
  }

  initializeForm() {
      this.formGroup = this.formBuilder.group({
        tipo: [
          { value: null, disabled: false },
           { validators: Validators.compose([Validators.required]) }
          ],
        anio: [
          { value: null, disabled: false },
         { validators: Validators.compose([Validators.required]) },
        ],
        fechaInicio: [
          { value: this.campania?.fechaDesde, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
        horaInicio: [
          { value: null, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
        fechaFinalizacion: [
          { value: this.campania?.fechaHasta, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
        horaFinalizacion: [
          { value: null, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
        campanaAsociada: [
          { value: this.campania?.campanaAsociada, disabled: true },
        ],
        descripcion: [
          { value: this.campania?.descripcion, disabled: false },
          { validators: Validators.compose([Validators.required]) },
        ],
        estado: [{ value: this.campania?.estado, disabled: false }],
      });

      this.formGroup.get('tipo')?.valueChanges.subscribe((tipo: any) => {
        if (tipo?.id === 'CVFGestor') {
            if(this.campaniaId){
              this.formGroup.get('descripcion')?.disable();
            } else {
              this.formGroup.get('descripcion')?.enable();
            }
            this.limpiarCampanaAsociada();
        } else if (tipo?.id === 'CVFPoseedor') {
            this.actualizarValidacionCampanaAsociada(true);
             if (!this.soloLectura) {
                this.formGroup.get('descripcion')?.enable();
             }
        } else {
             if (!this.soloLectura) {
                this.formGroup.get('descripcion')?.enable();
             }
             this.actualizarValidacionCampanaAsociada(false);
        }
      });

      this.formGroup.get('anio')?.valueChanges.subscribe((anio: any) => {
          if (this.formGroup.get('tipo')?.value?.id === 'CVFPoseedor') {
             if (anio && anio.toString().length === 4) {
                 this.cargarCampanasAsociadas(anio);
                 if (!this.soloLectura) {
                    if (this.campaniaId && (this.campania?.estado?.id !== 1)) {
                         this.formGroup.get('campanaAsociada')?.disable();
                    } else {
                         this.formGroup.get('campanaAsociada')?.enable();
                    }
                 }
             } else {
                 this.campanasAsociadas = [];
                 this.formGroup.get('campanaAsociada')?.setValue(null);
                 this.formGroup.get('campanaAsociada')?.disable();
             }
          }
      });

      if (this.soloLectura) {
        this.formGroup.disable();
      }
  }

  limpiarCampanaAsociada() {
    this.formGroup.get('campanaAsociada')?.clearValidators();
    this.formGroup.get('campanaAsociada')?.updateValueAndValidity();
    this.formGroup.get('campanaAsociada')?.setValue(null);
    this.formGroup.get('campanaAsociada')?.disable();
  }

  actualizarValidacionCampanaAsociada(required: boolean) {
      if (required) {
          this.formGroup.get('campanaAsociada')?.setValidators([Validators.required]);
          // Habilitar solo si hay año
          if (this.formGroup.get('anio')?.value) {
               if(!this.soloLectura) {
                  if(this.formGroup.get('tipo')?.value?.id === 'CVFPoseedor' && (this.campaniaId && this.campania?.estado?.id !== 1)){
                    this.formGroup.get('campanaAsociada')?.disable();
                  } else {
                    this.formGroup.get('campanaAsociada')?.enable();
                  }
               }
          } else {
               this.formGroup.get('campanaAsociada')?.disable();
          }
      } else {
          this.limpiarCampanaAsociada();
      }
      this.formGroup.get('campanaAsociada')?.updateValueAndValidity();
  }

  guardar() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }

    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    const formValue = this.formGroup.getRawValue();

    let fechaInicioCampania;
    let fechaFinCampania;
    fechaInicioCampania = this.buildFechaLocal(formValue.fechaInicio , formValue.horaInicio)
    fechaFinCampania = this.buildFechaLocal(formValue.fechaFinalizacion , formValue.horaFinalizacion)

    let tipoCampania;
    let anioCampania;
    let estadoCampania;
    if(this.campaniaId){
      tipoCampania = this.formGroup.get('tipo')?.value.id;
      anioCampania = this.campania?.anio;
      estadoCampania = this.campania.estado

    }else{
      tipoCampania = formValue.tipo.id;
      anioCampania = formValue.anio;
      estadoCampania = {id:1,descripcion:'PENDIENTE'}
    }
    const campaniaPayload: any = {

    anio: anioCampania,
    campanaAsociada: formValue.campanaAsociada,
    fechaInicio: fechaInicioCampania,
    fechaFinalizacion: fechaFinCampania,
    descripcion: formValue.descripcion,
    tipo: tipoCampania,
    estado: estadoCampania
  };

    let request, successMsg: string, errorMsg: string;
      if(this.campania){
        request = this.CamapanaService.editById(
          this.campania.id,
          campaniaPayload
        );
        successMsg = 'La campaña se ha editado correctamente.';
        errorMsg = 'Ha ocurrido un error al editar la campaña.';
      }else{
        request = this.CamapanaService.create(campaniaPayload);
        successMsg = 'La campaña se ha creado correctamente.';
        errorMsg = 'Ha ocurrido un error al crear la campaña.';
      }

      if(fechaFinCampania > fechaInicioCampania){
        const isCVF = (this.campaniaId && (this.campania?.tipo === 'CVFGestor' || this.campania?.tipo === 'CVFPoseedor')) || (formValue.tipo && (formValue.tipo.id === 'CVFGestor' || formValue.tipo.id === 'CVFPoseedor'));
        
        if (isCVF) {
          if (this.fechaLimiteSuperiorRaw && anioCampania) {
              const inicio = new Date(fechaInicioCampania);
              const limitYear = Number(anioCampania) + 1;
              
              // Fecha límite base segun BBDD
              const limitDateBase = new Date(limitYear, this.fechaLimiteSuperiorRaw.month - 1, this.fechaLimiteSuperiorRaw.day);
              
              // Calculamos fecha mínima permitida (Límite + 72 horas)
              const minAllowedDate = new Date(limitDateBase);
              minAllowedDate.setHours(minAllowedDate.getHours() + 72);
              
              if (inicio < minAllowedDate) {
                 // Formateamos la fecha para el mensaje
                 const dateStr = minAllowedDate.toLocaleDateString();
                 const timeStr = minAllowedDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
                 
                 this.snackBarSrv.showSnackBar(
                    `La fecha de inicio debe ser posterior a ${dateStr} ${timeStr} (Fecha límite + 72h).`,
                    'error'
                  );
                 return;
              }
          }

          if (this.campaniaId && (this.formGroup.get('fechaInicio')?.dirty || this.formGroup.get('horaInicio')?.dirty)) {
            const fechaActual = new Date();
            const fechaInicio = new Date(fechaInicioCampania);
            
            if (fechaActual > fechaInicio) {
              this.snackBarSrv.showSnackBar(
                'La fecha de inicio no puede ser anterior a la fecha actual.',
                'error'
              );
              return;
            }
          }

          if (!this.campaniaId) {
            const fechaActual = new Date();
            const fechaInicio = new Date(fechaInicioCampania);
            if (fechaActual > fechaInicio) {
              this.snackBarSrv.showSnackBar(
                'La fecha de inicio no puede ser anterior a la fecha actual.',
                'error'
              );
              return;
            }
          }
        }
        
        if(this.canEjecutarCampania()){
          this.spinnerSrv.loadingShow();
          request.subscribe({
            next: (response) => {
              this.spinnerSrv.loadingHide();
              if (this.formGroup.valid && this.titulo === 'Nueva campaña') {
                this.modalInformacionNuevaCampaña()
              } else {
                this.dialogRef.close(true);
              }
              this.snackbarService.showSnackBar(successMsg, 'success');
            },
            error: () => {
              this.spinnerSrv.loadingHide();
              this.snackbarService.showSnackBar(errorMsg, 'error');
            },
          });
        }else{
          this.snackBarSrv.showSnackBar(
            'La fecha de inicio debe ser, como mínimo, 48 horas posterior a la fecha actual.',
            'error'
          );
        }
      }else{
        this.snackBarSrv.showSnackBar(
          'La fecha de finalización tiene que ser mayor a la fecha de inicio.',
          'error'
        );
      }
  }

  confirmacionEjecucionCampania(): void {
    let texto;
    if(this.campania?.estado && (this.campania?.estado?.id === 1 || this.campania?.estado?.id === 6)){
      texto = `¿Desea ejecutar la campaña?`;
    } else{
      texto = `¿Desea relanzar la campaña?`;
    }

    Swal.fire({
      text: texto,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.lanzarCampania();
      }
    });
  }


  lanzarCampania(){
    let request = this.CamapanaAdheridosService.iniciarCampana({idCampana: this.campaniaId});
    let successMsg = 'La campaña se ha lanzado correctamente.';
    let errorMsg = 'Ha ocurrido un error al lanzar la campaña.';

    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(errorMsg, 'error');
      },
    });

  }

  lanzarCampaniaCVF(){
    let request = this.CamapanaPoseedoresService.iniciarCampana1({idCampana: this.campaniaId});
    let successMsg = 'La campaña se ha lanzado correctamente.';
    let errorMsg = 'Ha ocurrido un error al lanzar la campaña.';

    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(errorMsg, 'error');
      },
    });

  }
  finalizarCampaniaCVF(){
    let request = this.CamapanaPoseedoresService.finalizarCampana1({idCampana: this.campaniaId});
    let successMsg = 'La campaña se ha finalizado correctamente.';
    let errorMsg = 'Ha ocurrido un error al finalizar la campaña.';

    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(errorMsg, 'error');
      },
    });
  }


  cerrar(): void {
    this.dialogRef.close(null);
  }

  canEjecutarCampania() {
    const tipoId = this.formGroup.get('tipo')?.value?.id;
    const campaniaTipo = this.campania?.tipo;
    
    const campaniaTipoId = (campaniaTipo && typeof campaniaTipo === 'object') ? campaniaTipo['id'] : campaniaTipo;

    const isCVF = (tipoId === 'CVFGestor' || tipoId === 'CVFPoseedor') || 
                  (this.campania && (campaniaTipoId === 'CVFGestor' || campaniaTipoId === 'CVFPoseedor'));

    if (isCVF) {
      return true;
    }
    
    if(this.campania || (this.formGroup.get('fechaInicio')?.value && this.formGroup.get('horaInicio')?.value)){
      let fechaActual =  new Date();
      let fechaInicioCampania = new Date(this.buildFechaLocal(new Date(this.formGroup.get('fechaInicio')?.value) , this.formGroup.get('horaInicio')?.value));
      const diferenciaTiempo = fechaInicioCampania.getTime() - fechaActual.getTime();
      const diferenciaHoras = diferenciaTiempo / (1000 * 60 * 60);

      if(this.campania){
        return this.campania?.estado && (this.campania?.estado?.id === 1 || this.campania?.estado?.id === 6)
        && diferenciaHoras > 48;
      }else{
        return diferenciaHoras > 48;
      }
    }
  }

  //No se usa esta validación
  canRelanzarCampaniaCVF() {
    let anioCampania = this.formGroup.get('anio')?.value
    let fechaActual = new Date();
    let fechaLimite = new Date( anioCampania + 1, 1, 1)

    if(fechaActual >= fechaLimite && this.campania?.estado?.id === 1 ){
      return true;
    } else {
      return false;
    }
  }

  canLanzarCampaniaCVFPoseedor() {
    if (this.formGroup.get('tipo')?.value?.id !== 'CVFPoseedor') return false;

    const noEsEnCursoFinError = this.campania?.estado?.id !== 2 && this.campania?.estado?.id !== 5 && this.campania?.estado?.id !== 4;
    const campanaAsociadaFinalizada = this.campania?.campanaAsociada?.estado?.id === 5;
    let fechaFinNoAlcanzada = true;
    if (this.campania?.fechaFinalizacion) {
      const fechaActual = new Date();
      const fechaFin = new Date(this.campania.fechaFinalizacion);
      fechaFinNoAlcanzada = fechaActual <= fechaFin;
    }

    return noEsEnCursoFinError && campanaAsociadaFinalizada && fechaFinNoAlcanzada;
  }

  canFinalizarCampaniaCVF() {
    if (this.campania && this.campania.estado && this.campania.fechaFinalizacion) {
      const fechaActual = new Date();
      const fechaFin = new Date(this.campania.fechaFinalizacion);
      
      const tipoId = this.formGroup.get('tipo')?.value?.id;
      const campaniaTipo = this.campania?.tipo;
      const campaniaTipoId = (campaniaTipo && typeof campaniaTipo === 'object') ? campaniaTipo['id'] : campaniaTipo;

      if (campaniaTipoId === 'CVFPoseedor' || campaniaTipoId === 'CVFGestor') {
         return (this.campania.estado?.id !== 5 && this.campania.estado?.id !== 2) && fechaActual > fechaFin;
      }
    }
    return false;
  }

  canRelanzarCampania() {
    return this.campania?.estado && (this.campania?.estado?.id === 3 || this.campania?.estado?.id === 4)
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup?.controls[controlName]?.hasError(errorName) &&
      this.formGroup?.controls[controlName]?.touched
    );
  }

  buildFechaLocal(fecha : any, hora : any) {
  const d = new Date(fecha);
  const [h, m] = hora.split(":").map(Number);
  d.setHours(h, m, 0, 0);

  // Formato sin zona horaria: "YYYY-MM-DDTHH:mm:ss"
  return d.toLocaleString("sv-SE").replace(" ", "T");
}

  // anioValidation(anio: string) {
  //   this.formGroup.get('fechaInicio')
  //     ?.setValidators([
  //       Validators.required,
  //       this.validarFechaConAnio(anio),
  //     ]);
  //   this.formGroup.get('fechaInicio')?.updateValueAndValidity();

  //       this.formGroup.get('fechaFinalizacion')
  //     ?.setValidators([
  //       Validators.required,
  //       this.validarFechaConAnio(anio),
  //     ]);
  //   this.formGroup.get('fechaFinalizacion')?.updateValueAndValidity();
  // }

  validarFechaConAnio(anio: string) {
    return (control: AbstractControl) => {
      if (!control.value) return null;
      let year = control.value._i.year

      if(year === undefined){
        let fecha = new Date(control.value)
        year = fecha.getFullYear()
      }

      return year !== Number(anio)
        ? { fechaNoCoincide: true }
        : null;
    };
  }

  compararCampanas(o1: any, o2: any): boolean {
    return o1?.id === o2?.id;
  }

  modalInformacionNuevaCampaña(element?: any): void {
    const isCVFGestor = (this.formGroup.get('tipo')?.value?.id === 'CVFGestor' || this.formGroup.get('tipo')?.value?.id === 'CVFPoseedor');
      const text = isCVFGestor 
        ? `La campaña ha sido creada correctamente.` 
        : `Tras crear la campaña, vuelva a acceder para ejecutarla antes de las 48 horas previas a su inicio.`;
      
      Swal.fire({
        text: text,
        icon: 'info',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
      }).then((result: any) => {
        this.dialogRef.close();
      });
    }

}
